// All report datetimes are stored and returned as UTC. These zones only change which
// UTC window the report covers and how those instants are displayed.
export const REPORT_TIME_ZONES = [
    { code: 'UTC', label: 'UTC', ianaId: 'UTC' },
    { code: 'PT', label: 'Pacific (PT)', ianaId: 'America/Los_Angeles' },
    { code: 'MT', label: 'Mountain (MT)', ianaId: 'America/Denver' },
    { code: 'CT', label: 'Central (CT)', ianaId: 'America/Chicago' },
    { code: 'ET', label: 'Eastern (ET)', ianaId: 'America/New_York' },
];

export const DEFAULT_TIME_ZONE = 'UTC';

export const getIanaId = (code) =>
    REPORT_TIME_ZONES.find((x) => x.code === code)?.ianaId || 'UTC';

// Intl formatting is expensive and reports routinely render tens of thousands of rows,
// so formatters are built once per zone.
const formatterCache = new Map();

const getOffsetFormatter = (ianaId) => {
    if (!formatterCache.has(ianaId)) {
        formatterCache.set(
            ianaId,
            new Intl.DateTimeFormat('en-US', {
                timeZone: ianaId,
                hourCycle: 'h23',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            })
        );
    }
    return formatterCache.get(ianaId);
};

/**
 * Milliseconds to add to a UTC instant to get that zone's wall-clock time.
 * DST-aware, since the offset is resolved for the specific instant.
 */
export const getZoneOffsetMs = (date, code) => {
    const ianaId = getIanaId(code);
    if (ianaId === 'UTC') return 0;

    const parts = getOffsetFormatter(ianaId)
        .formatToParts(date)
        .reduce((acc, part) => {
            acc[part.type] = part.value;
            return acc;
        }, {});

    const asUtc = Date.UTC(
        Number(parts.year),
        Number(parts.month) - 1,
        Number(parts.day),
        Number(parts.hour) % 24,
        Number(parts.minute),
        Number(parts.second)
    );

    return asUtc - date.getTime();
};
